<template>
        <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled" id="menu-patients">
            
            <li 
                class="sidebar-sub-menu-item"
                v-for="list in lists" :key="list.uuid" @click.prevent="handleClick($event)">
                <router-link
                    :to="'/dashboard?report='+`${list.id}`"
                    @click="isActive(list.id)"
                    @click.prevent="handleClick($event)"
                    :class="['sidebar-sub-menu-link', { active: activeIndex === list.uuid }]"
                    >

                    {{ list.name }}
                
                </router-link>
                
            </li>
            
          </ul>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import axios from "axios";
import configs from "@/utils/configs";
import onSystem from "@/utils/getSystemOn";


interface PatientData {
  name: string;
  id: string;
}

const patients = ref([]) as any;  // Armazena os dados dos pacientes

const loadPatientJsons = async ()=>{
  let folderBucket = await onSystem();

  const response = await axios.get(configs.urlApiFiles+'/api/v1/list-files?folder='+folderBucket+'/CMJ5');
 
  let cleanJsonFiles = response.data.map((file:any) => {
    let uuidMatch = file.split('__')[1];
    uuidMatch = uuidMatch.replace('.json', '');
    // Se encontrar o UUID, retornar o UUID seguido de .json
    return uuidMatch;
  });

  //gravar a versao da lista do bucket S3
  localStorage.setItem('patients_bucket_json', '');
  localStorage.setItem('patients_bucket_json', JSON.stringify(response.data));

  localStorage.setItem('patients_jsons', '');
  localStorage.setItem('patients_jsons', JSON.stringify(cleanJsonFiles));
}

const userPatientFiles = async () => {
  const patients = ref<PatientData[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);


  try {
    let systemOn:string | any = localStorage.getItem('on_system');

    if(systemOn){
      systemOn = JSON.parse(atob(systemOn));
      const response = await axios.get(`${configs.urlApiFiles}/api/v1/list-files?folder=${systemOn.id}/CMJ5`);
      const files = response.data as string[];

      patients.value = files.map((file) => {
        const [name, id] = file.split('_CMJ5_history__');
        return { name, id: id.replace('.json', '') };
      });
    }

    return patients.value;
  } catch (err) {
    error.value = 'Erro ao buscar os arquivos de pacientes';
  } finally {
    loading.value = false;
  }
  return null;
};
const fetchPatientsApi = async () => {
  const loading = ref(true);
  const error = ref(null);
  try {
    
    //const response = await axios.get(configs.urlApiFiles+'/api/v1/patients')
    
    // Armazena o array "results" dos pacientes na constante reativa
    let arrPatients = await userPatientFiles();
    patients.value = arrPatients;
        
    //filtrar o menu para apenas os pacientes do system trabalhado
    //let filteredPatients = patients.value.filter((patient:any) => pacientsIds.includes(patient.id));
    
    let filteredPatients = patients.value.sort((a:any, b:any) => a.name.localeCompare(b.name));
    
    //rendenrizando o menu
    patients.value = filteredPatients;
  
    
    
  } catch (err: any) {
    // Armazena o erro na constante reativa
    error.value = err.message || 'Erro ao buscar pacientes'
  } finally {
    // Finaliza o estado de carregamento
    loading.value = false
  }
}

export default defineComponent({
  name: "PatientsMenu",
  data() {
    return {
      lists: patients,
      patientsResults: {} as any,
      objPatientsApi: [] as any,
      activeUuid: null,
    };
  },
  mounted(){
    fetchPatientsApi();
    this.showPatientsRelational();
    //consulta a API JSON FILES e ver quais UUIDS estao cadastrados
    loadPatientJsons();
    
  },
  methods: {
    
    showPatientsRelational(){
      let assessments:string | any = localStorage.getItem('on_assessments');
      let system:string | any = localStorage.getItem('on_system');
      if(assessments){
        assessments = JSON.parse(atob(assessments));
        system = JSON.parse(atob(system));
        //varrer todos os IDs de listPatients.uuid relacionados a um assessments.patient
        
        let uniquePatients = assessments.reduce((acc, patient) => {
          // Verifica se o paciente já está no array acumulado
          if (!acc.some(p => p.patient === patient.patient)) {
            acc.push(patient);
          }
          return acc;
        }, []);
        let pacientsIds:any = [];
        uniquePatients.forEach((access:any) => {
          //versao para desenvolvimento
            //if(/* access.system === system.id || */ access.system === "dfcc87e4-51c1-43b2-9fec-c5ffe227e369"){
          //versao para subir ao servidor
            if( access.system === system.id ){
              
              if(access.patient){
                pacientsIds.push(access.patient);
              }
              
            }
            
        });
        
        //filtrar o menu para apenas os pacientes do system trabalhado
        let filteredPatients = patients.value.filter((patient:any) => pacientsIds.includes(patient.id));
        
        
        filteredPatients.sort((a:any, b:any) => a.name.localeCompare(b.name));
        //rendenrizando o menu
        this.lists= filteredPatients;
      }
    },
    getQueryParam(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    },
    removeActiveClass() {
      // Seleciona todos os itens com a classe 'active' e remove a classe
      const activeItems = document.querySelectorAll('.sidebar-sub-menu-item');
      activeItems.forEach(item => item.classList.remove('actives'));
    },
    isActive(uuid: string) {
      this.removeActiveClass();
      setTimeout(() => {
        this.removeActiveClass();
      }, 500);
      // Obter o UUID da query string
      const reportId = this.getQueryParam('report');

      // Selecionar todos os itens do menu
      const menuItems = document.querySelectorAll('.sidebar-sub-menu-item a');
  
      // Verificar qual item corresponde ao UUID na URL
      setTimeout(() => {
        
        menuItems.forEach((item: any) => {
          const href = item.getAttribute('href');
          const uuidInHref = new URLSearchParams(href.split('?')[1]).get('report');
          // Se o UUID no href for igual ao da query string, adicionar a classe "active"
          if (uuidInHref === uuid) {
            item.parentElement.classList.add('actives');
          }
        });
      }, 1000);
     
      
      return this.activeUuid === uuid;
    },
    handleClick(event: Event){
      // Remove a classe 'active' de todos os links
      const menu = document.getElementById("menu-patients");
      if (menu) {
        const links = menu.querySelectorAll(".sidebar-sub-menu-link");
        links.forEach((link) => link.classList.remove("active"));
      }

      // Adiciona a classe 'active' ao link clicado
      const target = event.currentTarget as HTMLElement;
      if (target) {
        target.classList.add("active");
      }
    }
  },
  setup() {

    // Índice do item ativo
    const activeIndex = ref<number | null>(null);

    // Método para definir o item ativo
    const setActive = (index: number) => {
      activeIndex.value = index;
    };

    return {
      activeIndex,
      setActive,
    };
  },
  
  
});
</script>
<style scoped>
li .sidebar-sub-menu-item, a{
  padding-bottom: 0px;
  padding-top: 0px;
}

/* Estilo para o item ativo */
.actives {
  background-color: #6560f0;
}
</style>
